import { useTranslation } from 'react-i18next'

import { Box as DarkBox } from '@hivewatch/dark'

import { darkFloorsPanelStyles } from './DarkFloorsPanel.styles'

interface DarkFloorsPanelHeaderIProps {
  colorScheme: 'dark' | 'light'
}

// Header slot for the rail's SidePanel: plain text with no leading icon —
// ENG-31744 precedent.
export const DarkFloorsPanelHeader = ({
  colorScheme,
}: DarkFloorsPanelHeaderIProps) => {
  const { t } = useTranslation()
  const s = darkFloorsPanelStyles(colorScheme)

  return (
    <DarkBox display='flex' flexDirection='column' gap='8px'>
      <DarkBox as='h2' {...s.headerTitle}>
        {t('floors:floors_panel_header_title')}
      </DarkBox>
      <DarkBox {...s.headerDescription}>
        {t('floors:floors_panel_header_description')}
      </DarkBox>
    </DarkBox>
  )
}
